<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-40px">
          <h1 class="title is-size-3">
            {{ $t('general.popUpChangeUser.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="error"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="error = $event"/>
      <div class="columns is-multiline">
        <div class="column is-12">
          <user-selector
            v-model="payload.userId"
            :label="$t('general.popUpChangeUser.selectUser')"
            :critere="(user) => user.id !== utilisateur.id"
            obligatoire
          />
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('general.popUpChangeUser.password')"
            class="obligatoire">
            <b-input
              v-model="payload.password"
              type="password"
              autocomplete="current-password"
              password-reveal>
            </b-input>
          </b-field>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="actionLogin">
              {{ $t('general.button.next') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import UserSelector from '@/components/commun/user/userSelector';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import messageInformation from '@/services/general/messageInformation';
import validation from '@/services/connexion/connexionMessageErreur';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/connexion/champsConnexionTranslator';
import DOMAINE from '@/configuration/bodac/contact/contactConf';
import { PAGE_DEFAULT } from '@/router/routerConf';

const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'PChangeUser',
  components: {
    UserSelector,
    ErrorMsgComponent,
  },
  data() {
    return {
      payload: {
        userId: null,
        password: null,
      },
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
      utilisateur: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      // le load se fait dans userSelector.vue
      return cloneDeep(this.parametre(PARAMETRES_KEYS.utilisateur));
    },
  },
  methods: {
    ...User.mapActions({
      actionLogIn: 'logIn',
      actionLogOut: 'logOut',
    }),
    ...Parametres.mapActions({
      purgerParametres: 'purgerParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapActions({
      setMultipleAgenceActive: 'setMultipleAgenceActive',
      actionsSetSocieteId: 'setSocieteId',
      actionsSetSocieteOfUser: 'setSocieteOfUser',
      loadSocietes: 'loadSocietes',
    }),
    ...Permissions.mapActions({
      loadPermissions: 'loadPermissions',
    }),
    ...CategorieVente.mapActions({
      purgerCategorieVente: 'purgerCategorieVente',
    }),
    async actionLogin() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      const user = this.users.find(user => user.id === this.payload.userId);
      try {
        await this.actionLogIn({
          site: this.site,
          password: this.payload.password,
          email: this.utilisateur.identifiant,
          secondaryUserNameOrEmailAddress: user?.identifiant,
          noLogout: true,
        });
        if (this.utilisateur.domaine === DOMAINE) {
          await this.actionLogOut();
          messageInformation(this.$t('connexion.info.infoConnexionPortail'), 'is-danger');
          return;
        }
        this.purgerParametres();
        await this.loadPermissions();
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.autoriserAuthentificationAffixe1.key]);
        await this.loadSocietes({});
        await this.actionsSetSocieteOfUser(this.utilisateur);
        await this.setMultipleAgenceActive(this.utilisateur.agences.filter((agence) => {
          return agence.societeId === this.utilisateur.agence.societeId;
        }));
        await this.actionsSetSocieteId(this.utilisateur.agence.societeId);
        await this.purgerCategorieVente();
        this.$parent.close();
        this.$router.go(PAGE_DEFAULT);
      } catch (e) {
        this.error = true;
        const hasServerError = e.response?.data?.error || e.response?.data?.result?.details;
        if (!hasServerError) {
          messageErreur(this.$i18n);
          return;
        }
        if (hasServerError) {
          this.messages = validation(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
        }
        if (!this.payload.userId) {
          this.champsVide.push(this.$t('connexion.required.secondaryUserNameOrEmailAddress'));
        }
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
